import { ApiBase } from '../apiBase';
import {
  HexaInterestArea,
  HexaBaseInterestArea,
  LOCAL_POLITICIANS_COUNTRIES,
} from './models/SharedModels';

const BASE_INTEREST_AREAS: HexaBaseInterestArea[] = [
  'adverse_media',
  'pep',
  'local_politicians',
  'legal_enforcement',
  'sanctions',
  'whitelists',
  'public_functions',
];

export class ApiHexaBase extends ApiBase {
  static INTEREST_AREAS: Array<HexaInterestArea> = [
    ...BASE_INTEREST_AREAS,
    ...Object.keys(LOCAL_POLITICIANS_COUNTRIES).map(
      (code) => `local_politicians_${code}` as HexaInterestArea
    ),
  ];

  public static get baseUrl(): string {
    return '/hexa';
  }
}
